import * as Providers from './base';

export default class Yandex extends Providers.Base {
	set(data) {
		super.set(this.data.goal_params, data);
	}

	send(callback) {
		super.send(() => {
			window.ym(
				window.yandex_metrika_id,
				'reachGoal',
				this.data.goal_name,
				this.data.goal_params,
				this._function_with_timeout(callback)
			);
		}, callback);
	}
}
